var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20483_58993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.47 6.19453C23.3323 5.6858 23.0638 5.22201 22.6911 4.84934C22.3185 4.47667 21.8547 4.20812 21.346 4.07044C19.4835 3.5625 11.9878 3.5625 11.9878 3.5625C11.9878 3.5625 4.49177 3.57787 2.62933 4.08581C2.1206 4.2235 1.65681 4.49206 1.28415 4.86475C0.911497 5.23744 0.642976 5.70125 0.505331 6.21C-0.0580132 9.51919 -0.276545 14.5616 0.520799 17.7384C0.658459 18.2472 0.926986 18.711 1.29964 19.0836C1.6723 19.4563 2.13608 19.7248 2.6448 19.8625C4.50724 20.3705 12.0031 20.3705 12.0031 20.3705C12.0031 20.3705 19.4989 20.3705 21.3612 19.8625C21.87 19.7249 22.3338 19.4563 22.7064 19.0836C23.0791 18.711 23.3477 18.2472 23.4853 17.7384C24.0795 14.4246 24.2626 9.38522 23.47 6.19453Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60156 15.5681L15.8198 11.9664L9.60156 8.36475V15.5681Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20483_58993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.875,
    fill: "white",
    transform: "translate(0 3.5625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cfa98a0426021dfcc028b2baa01f5b56.svg";
export { ForwardRef as ReactComponent };